export const USER_STATS_TAB = {
  OVERVIEW: 'overview',
  ACTIVITY: 'activity',
  COURSES: 'courses',
  TESTS: 'tests',
} as const;

export type UserStatsTab = (typeof USER_STATS_TAB)[keyof typeof USER_STATS_TAB];

const USER_STATS_TABS: string[] = Object.values(USER_STATS_TAB);

export function isUserStatsTab(value: string): value is UserStatsTab {
  return USER_STATS_TABS.includes(value);
}
